import { render, staticRenderFns } from "./relationship-recognition-edit.vue?vue&type=template&id=fde7f862&scoped=true"
import script from "./relationship-recognition-edit.vue?vue&type=script&lang=js"
export * from "./relationship-recognition-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde7f862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fde7f862')) {
      api.createRecord('fde7f862', component.options)
    } else {
      api.reload('fde7f862', component.options)
    }
    module.hot.accept("./relationship-recognition-edit.vue?vue&type=template&id=fde7f862&scoped=true", function () {
      api.rerender('fde7f862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/seedFarm-management/relationship-recognition/relationship-recognition-edit.vue"
export default component.exports